import { render, staticRenderFns } from "./ReceiveAddressComparison.vue?vue&type=template&id=954f399c&scoped=true"
import script from "./ReceiveAddressComparison.vue?vue&type=script&lang=js"
export * from "./ReceiveAddressComparison.vue?vue&type=script&lang=js"
import style0 from "./ReceiveAddressComparison.vue?vue&type=style&index=0&id=954f399c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954f399c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('954f399c')) {
      api.createRecord('954f399c', component.options)
    } else {
      api.reload('954f399c', component.options)
    }
    module.hot.accept("./ReceiveAddressComparison.vue?vue&type=template&id=954f399c&scoped=true", function () {
      api.rerender('954f399c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/orderLogs/ReceiveAddressComparison.vue"
export default component.exports